module.exports = __webpack_public_path__ + "798d23d2dfe71efd8adbeee98589f2c1.svg";